import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessIxHansaInvestBuExportStatus: 'idle',
    startProcessIxHansaInvestBuExportError: undefined as any,
    loadUserParamsProcessIxHansaInvestBuExportStatus: 'idle',
    loadUserParamsProcessIxHansaInvestBuExportError: undefined as any,

    processIxHansaInvestBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessIxHansaInvestBuExport = createAsyncThunk('processIxHansaInvestBuExportSlice/startProcessIxHansaInvestBuExport', async ({ processIxHansaInvestBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessIxHansaInvestBuExport/`,
        prepareData(processIxHansaInvestBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessIxHansaInvestBuExportStatus } = getState().processIxHansaInvestBuExportSlice
        return startProcessIxHansaInvestBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessIxHansaInvestBuExport = createAsyncThunk('processIxHansaInvestBuExportSlice/loadUserParamsProcessIxHansaInvestBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessIxHansaInvestBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessIxHansaInvestBuExportStatus } = getState().processIxHansaInvestBuExportSlice
        return loadUserParamsProcessIxHansaInvestBuExportStatus !== 'pending'
    }
})

const ProcessIxHansaInvestBuExportSlice = createSlice({
    name: 'processIxHansaInvestBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessIxHansaInvestBuExport: (state) => {
            state.job = undefined
            state.startProcessIxHansaInvestBuExportError = undefined
        },
        resetstartProcessIxHansaInvestBuExportError: (state) => {
            state.startProcessIxHansaInvestBuExportError = undefined
        },
        resetloadUserParamsProcessIxHansaInvestBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessIxHansaInvestBuExportError = undefined
        },
        resetloadUserParamsProcessIxHansaInvestBuExportError: (state) => {
            state.loadUserParamsProcessIxHansaInvestBuExportError = undefined
        },
        removeFromProcessIxHansaInvestBuExportListById: (state, action) => {
            state.processIxHansaInvestBuExportList = state.processIxHansaInvestBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessIxHansaInvestBuExportListByIds: (state, action) => {
            state.processIxHansaInvestBuExportList = state.processIxHansaInvestBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processIxHansaInvestBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessIxHansaInvestBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processIxHansaInvestBuExportList = []
            state.startProcessIxHansaInvestBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessIxHansaInvestBuExport.pending, (state) => {
            state.startProcessIxHansaInvestBuExportStatus = 'pending'
            state.startProcessIxHansaInvestBuExportError = undefined
        })
        builder.addCase(startProcessIxHansaInvestBuExport.fulfilled, (state, action) => {
            state.startProcessIxHansaInvestBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessIxHansaInvestBuExport.rejected, (state, action) => {
            state.startProcessIxHansaInvestBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessIxHansaInvestBuExportError = action.error.message
            } else {
                state.startProcessIxHansaInvestBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessIxHansaInvestBuExport.pending, (state) => {
            state.loadUserParamsProcessIxHansaInvestBuExportStatus = 'pending'
            state.loadUserParamsProcessIxHansaInvestBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessIxHansaInvestBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessIxHansaInvestBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessIxHansaInvestBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessIxHansaInvestBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessIxHansaInvestBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessIxHansaInvestBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessIxHansaInvestBuExport,
    resetstartProcessIxHansaInvestBuExportError,
    resetloadUserParamsProcessIxHansaInvestBuExport,
    resetloadUserParamsProcessIxHansaInvestBuExportError,
    removeFromProcessIxHansaInvestBuExportListById,
    removeFromProcessIxHansaInvestBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessIxHansaInvestBuExportSlice.actions
export default ProcessIxHansaInvestBuExportSlice.reducer
